import { Component, OnInit, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../registration.service';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { FormatNumberPipe } from '@app/@core/pipes/format-number.pipe';
import { VALIDATORS } from '@app/@core/entities/validators.constant';

@Component({
  standalone: false,
  selector: 'app-phone-update',
  templateUrl: './phone-update.component.html',
  styleUrls: ['./phone-update.component.scss']
})
export class PhoneUpdateComponent  implements OnInit{

  phoneForm = new FormGroup({
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.pattern(VALIDATORS.MAX_PHONE_NUMBER_PATTERN)
    ])
  });

  get phoneNumber() {
    return this.phoneForm.get('phoneNumber');
  }


  // Toast message properties
  showToast: boolean = false;
  toastMessage: string = '';
  toastType: 'success' | 'error' = 'success';
  private toastTimer: any;
  isLoading: boolean = false;
  isSubmitDisabled: boolean = true;

  // Store email from query parameters to preserve it
  private currentEmail: string = '';
  private recoveryEmail: string = '';
  buttonHide: boolean = false;
  private currentPhone: string = '';
  private source: string = 'phone-verification';
  private recoveryEmailVerified: string = '';

  phoneExist: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly registrationService: RegistrationService,
    private readonly formatNumberPipe : FormatNumberPipe
  ) {
   this.route.queryParams.pipe(take(1), takeUntil(this.destroy$)).subscribe(params => {
      if (params['email']) {
        this.currentEmail = params['email'];
        this.recoveryEmail = params['recoveryEmail'] || '';
      }
      if (params['phone']) {
        this.currentPhone = params['phone'];
      }
      if (params['source']) {
        this.source = params['source'];
      }
      if (params['recoveryEmailVerified']) {
        this.recoveryEmailVerified = params['recoveryEmailVerified'];
      }
    });
  }
  genericMessages: any[] = [];
  errorMessages: any = {};
  genericMessage: any = {};
  errorMessage: string = '';
  toastMessages: any[] = [];
  toastDbMessage: any = {};

  ngOnInit(): void {
    const storedErrorMessages: any = JSON.parse(window.localStorage.getItem('errorMessages'));   
    storedErrorMessages.forEach(message => {
      if (message.key && message.value !== undefined) {
        this.errorMessages[message.key] = message.value;
      }
    });
    const storedGenericMessages = window.localStorage.getItem('genericMessages');
      this.genericMessages = JSON.parse(storedGenericMessages);
        this.genericMessage = {};
    this.genericMessages.forEach(message => {
      if (message.key && message.value !== undefined) {
        this.genericMessage[message.key] = message.value;
      }
    });
    const storedToastMessages = window.localStorage.getItem('toastMessages');
      this.toastMessages = JSON.parse(storedToastMessages);

      this.toastDbMessage = {};
      this.toastMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.toastDbMessage[message.key] = message.value;
        }
      });

  }

  // HostListener to handle input & paste events on phone number field
  @HostListener('input', ['$event'])
  @HostListener('paste', ['$event'])
  onUnifiedInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target && target.id === 'input_phone_update_phone_number') {
     if (this.phoneNumber?.valid && !this.phoneNumber?.hasError('required') && !this.phoneNumber?.hasError('pattern')) {
        this.isSubmitDisabled = false;
      }
      this.handlePhoneNumberInput(event);
    }
  }
  

  // Phone number masking method
  handlePhoneNumberInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.phoneExist = false;
    
    const formatted = this.formatNumberPipe.transform(target.value);
    this.phoneNumber?.setValue(formatted, { emitEvent: false });

    const cleanedValue = formatted?.replace(/\D/g, '') || '';
    
    if(this.phoneNumber?.valid && cleanedValue.length >= 10){
      this.checkPhone();
    } else {
      this.isSubmitDisabled = true;
    }
  }

  onPhoneNumberInput(event: any): void {
  let input = event.target.value
  const formattedValue = this.formatNumberPipe.transform(input)
  this.phoneForm.get('phoneNumber')?.setValue(formattedValue, { emitEvent: false });
  }

  onSubmit() {

    if (this.phoneForm.valid) {

      this.isSubmitDisabled = true;
      this.buttonHide = true;
      this.isLoading = true;
      let phoneNumber = this.phoneNumber?.value.replace(/\D/g, '').replace(/^1(\d{10})$/, '$1');
      
      // Call the update phone API
      let request = {
          email: this.currentEmail,
          primaryPhone: phoneNumber,
      };
      this.registrationService.updateNewPhone(request).pipe(take(1), takeUntil(this.destroy$)).subscribe({  
        next: response => {
          if (response.status === 'success') {
            // Send email notification
            this.phoneNumberEmailSend();
            
            const updatedPhoneNumber = this.phoneNumber?.value.replace(/\D/g, '');
            
            // Preserve both email and phone parameters
            const queryParams: any = {};
            if (this.currentEmail && this.recoveryEmail === '') {
              queryParams.email = this.currentEmail;
            }else if(this.currentEmail && this.recoveryEmail !== ''){
              queryParams.email = this.currentEmail;
              queryParams.recoveryEmail = this.recoveryEmail;
            }
            if (updatedPhoneNumber) {
              queryParams.phone = encodeURIComponent(updatedPhoneNumber);
            }
            
            // Navigate to login page after showing toast message
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 10000);
          } else {
            // Handle non-success response
            this.isSubmitDisabled = false;
            this.isLoading = false;
          }
        },
        error: error => {
          console.error('Error Updating Phone:', error);
          this.isSubmitDisabled = false;
          this.isLoading = false;
        }
      });
    } else {
      console.log('Form is invalid');
    }
  }

  get request(){
    const updatedPhoneNumber = this.phoneNumber?.value.replace(/\D/g, '');
    return this.recoveryEmail === '' ? {email: this.currentEmail, primary_phone: updatedPhoneNumber, front_end_domain: environment.frontEndDomain}
                                     : {email: this.currentEmail, recovery_email: this.recoveryEmail, primary_phone: updatedPhoneNumber, front_end_domain: environment.frontEndDomain}
  }

   phoneNumberEmailSend() {
    this.registrationService.updatePhoneNumberNotification(this.request).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: response => {
        const toastText = this.toastDbMessage['T0009'] || 'A new confirmation link has been sent to your email. Please check your inbox and Spam/Junk folders.';
        this.showToastMessage(toastText, 'success');
      },
      error: error => {
        this.isLoading = false;
        console.error('Error sending phone number update email notification:', error);
      }
    });
  }


  showToastMessage(message: string, type: 'success' | 'error' = 'success'): void {
    this.toastMessage = message;
    this.toastType = type;
    this.showToast = true;

    // Auto-hide toast after 2 seconds and navigate only on success
    this.toastTimer = setTimeout(() => {
      this.closeToast();
    }, 5000);
  }

  closeToast(): void {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  get isPhoneNumberInvalid(): boolean {

    if(this.phoneExist){
      this.errorMessage = this.errorMessages['M0087'];
      this.isSubmitDisabled = true;
      return true;
    }else if(this.phoneNumber?.touched && this.phoneNumber?.hasError('pattern') && !this.phoneNumber?.valid){
      this.errorMessage = this.errorMessages['M0017'];
      this.isSubmitDisabled = true;
      return true;
    }else if(this.phoneNumber?.touched && this.phoneNumber?.hasError('required')){
      this.errorMessage = this.errorMessages['M0016'];
      this.isSubmitDisabled = true;
      return true;
    }
    
    return false;
  }

  checkPhone() {
    
    let cleanedPhoneNumber = this.phoneNumber?.value.replace(/\D/g, '');

    let request = {
      phone: cleanedPhoneNumber
    };
    
    this.isSubmitDisabled = false;
    
    this.registrationService.checkPhone(request).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: response => {
        if (response.data.exists === true) {
          this.phoneExist = true;
          this.isSubmitDisabled = true;
          this.showToastMessage(this.toastDbMessage['T0004'], 'error');
        } else {
          this.phoneExist = false;
          this.isSubmitDisabled = false;
        }
      },
      error: error => {
        console.error('Error checking phone:', error);
        this.isSubmitDisabled = true;
      }
    });
  }

  onCancel(): void {
    if (this.source === 'phone-recovery-email') {
      const queryParams: any = {
        email: this.currentEmail,
        phone: this.currentPhone
      };
      
      if (this.recoveryEmail) {
        queryParams.recoveryEmail = this.recoveryEmail;
      }
      
      if (this.recoveryEmailVerified === 'true') {
        queryParams.recoveryEmailVerified = 'true';
        localStorage.setItem('recoveryEmailVerified', 'true');
      }
      
      this.router.navigate(['../phone-recovery-email'], {
        relativeTo: this.route,
        queryParams: queryParams
      });
    } else {
      this.router.navigate(['../phone-verification'], {
        relativeTo: this.route,
        queryParams: {
          email: this.currentEmail,
          phone: this.currentPhone
        }
      });
    }
  }

  get isSubmitButtonDisabled(): boolean {
    return this.isSubmitDisabled || this.isLoading;
  }

  // Phone number formatting
  formatPhoneNumber(event: any) {
    let input = event.target.value;
    const isDeleting = event.inputType === 'deleteContentBackward';

    if (/[a-zA-Z]/.test(input)) {
      input = input.replace(/[a-zA-Z]/g, '');
    }

    //Auto prepend +1 only when typing (not deleting)
    if (!isDeleting && !input.startsWith('+1') && input !== '+') {
      input = '+1 ' + input.replace(/^\+/, '');
    }

    if (!input) {
      this.phoneForm.get('phoneNumber')?.setValue('', { emitEvent: false });
      return;
    }

    if (input.startsWith('+1')) {
      if (input.length > 2 && input[2] !== ' ') {
        if (event.inputType !== 'deleteContentBackward') {
          input = '+1 ' + input.slice(2);
        }
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      // Strip repeated country code: e.g. user pasted 18XXXXXXXXX after field already had "+1 "
      if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.substring(1);
      }
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      let finalValue = input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
      this.phoneForm.get('phoneNumber')?.setValue(finalValue, { emitEvent: false });
      return;
    }

    if (input === '+' || input === '+1' || input === '+1 ') {
      this.phoneForm.get('phoneNumber')?.setValue(input, { emitEvent: false });
      return;
    }

    this.phoneForm.get('phoneNumber')?.setValue('', { emitEvent: false });
    return;
  }

ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete()
  }

}
